angular.module('ui2.0Directives')
    .directive('contractLineItem', ['$rootScope','$uibModal','$timeout','$routeParams','$window',"$compile","contractLineItemService","showPageService","cliCommonService", function ($rootScope,$modal,$timeout,$routeParams,$window,$compile,contractLineItemService,showPageService,cliCommonService){
        return {
            restrict:'AE',
            templateUrl :$rootScope.createHtmlUrl("ui2.0/directiveTemplates/contractLineItem.html"),
            link : function($scope,element,attrs){
                $scope.tableData = {};
                $scope.row = {};
                $scope.editable = false;
                $scope.tableColumn = [];
                $scope.ERROR_TYPE = {
                    validation: "Validation Error",
                    configuration:"Configuration Error"
                }
                $scope.drpDwnState = {
                    download: false,
                    bulkActivity: false,
                    bulkCreate: false,
                    bulkEdit: false,
                    downloadActivity:false,
                    isDownload : false,
                    allTableMoreMenu: false,
                    downloadTemplate: false,
                }
                $scope.allowBulkUpdate = false
                $scope.CliPaginationData = {};
                $scope.fieldTypeMap = {};
                $scope.selectAllBtn = {value:false};
                $scope.extraRowCount = 0;
                $scope.globalEdit = false;
                $scope.previousState = null;
                $scope.previousStateSingleRow = {}
                $scope.selectedRowCount = 0;
                $scope.hasSingleEditableRows = 0;
                $scope.rowData;
                $scope.generatePopupDynamicClass = '';
                $scope.bulkRowEdit = false;
                $scope.bulkSelectedRows = {};
                $scope.wordLineItemDocs = [];
                $scope.validExcelExtension = ['xlsx','xlsm'];
                $scope.isNoFilterData = false;
                $scope.filterApplied = false;
                $scope.filterOpened = false;
                $scope.filteredCount = null;
                $scope.tableChanged = false;
                $scope.fromReset = false;
                $scope.tableCliListData = {};
                $scope.isTableExpanded = false;
                $scope.reloadDataGrid = false;
                $scope.downloadData = {
                    exclude: {},
                    include: {},
                    isSelectAllClicked: false,
                };
                $scope.updatedDocInfo = {
                    docName: '',
                    lastDocUpdated: '',
                    lastLineItemUpdated: '',
                    updateFlag: false,
                    ext: 'docx',
                    docId: '',
                    generateDocument: false
                }
                $scope.selectedRows = {};
                $scope.activeRowId = null;
                $scope.selectedWordDoc;
                $scope.editLineItem = false;
                $scope.selectPlaceHolder = 'Select';
                $scope.options = {};
                $scope.masterOptions = {};
                $scope.validationStatus = {
                    "1": "Successful",
                    "2" : "Failed",
                    "3": "In-Progress",
                }
                $scope.mssettings = {
                    displayProp: "name",
                    "selectedToTop": true,
                    scrollableHeight: '200px',
                    scrollable: true,
                    "externalIdProp": '',
                    'enableSearch': true,
                    'parentElmClass': 'jx-parentForm',
                    'isCli': true
                };
                $scope.allTemplates = [];
                $scope.allTables = [];
                $scope.currentSelectedTable = {};
                $scope.templateIdNameMap = {};
                $scope.multiTableViewAllowed = [160, 61].includes(_.get($scope,"data.entityTypeId.values"));
                $scope.fromFilter = false;
                $scope.showErrorMsgForCLITable = false;
                $scope.errorMsgForCLI = null;
                $scope.clickAddRowButton = false;
                $scope.isTableNameEditable = false;
                $scope.fromCommentsSaveBtn = false;
                $scope.resetFilters = false;

                $scope.openCLIFilters = () => {
                    const initializeFilterDialog = () => {
                        $("#elasticSearchFilter").dialog({
                            dialogClass: 'myPosition',
                            modal: true,
                            width: 1010,
                            height: 'auto',
                            resizable: false,
                            draggable: false,
                            open: function () {
                                resetDialogPosition(this);
                            }
                        });

                        $scope.fromFilter = true;
                        $scope.filterOpened = true;
                    };
                    initializeFilterDialog();
                }

                $scope.openImportCLIFilters = () => {
                    $("#elasticImportSearchFilter").dialog({
                        dialogClass: 'myPosition',
                        modal: true,
                        width: 1010,
                        height: 'auto',
                        resizable: false,
                        draggable: false,
                        open: function () {
                            resetDialogPosition(this);
                        }
                    });
                }

                $scope.bulkCreateEditUploadReactHandler = (isBulkCreate) => {
                    $scope.mountCommentsAndAttachmentsModal(isBulkCreate, $scope);
                }

                $scope.generateDocOpenModal = (generateType) => {
                    contractLineItemService.generateDocOpenModal(generateType);
                }

                $scope.uploadBulkFile = function () {
                    if(_.isNil($scope.inputElement)){
                        $scope.showError = true;
                        return;
                    }
                    $scope.showError = false;
                    $scope.postErrors = false;
                    contractLineItemService.uploadBulkFile.call($scope, $scope.inputElement, $scope.isbulkCreated);
                };
                $scope.bulkCreateEditUploadHandler = (isBulkCreate = true) => {
                    $("#upload_excel_cli").dialog({
                        autoOpen: false,
                        height: "auto",
                        width: 650,
                        modal: true,
                        resizable: false,
                        open: function (event, ui) {
                            $('[aria-describedby="upload_excel_cli"] .ui-dialog-titlebar-close').attr('title', intl_msg[24237]);
                            $("#uploadExcel").show();
                            $("#uploadExcel").find("input[type='file']").val("");
                            $("#upload_excel_cli #fileName").text("");
                            $("#upload_excel_cli label.file_name").text(intl_msg[25719]);
                            $scope.showError = false;
                            $scope.inputElement = null;
                            $scope.postErrors = false;
                            $scope.extError = false;
                            resetDialogPosition(this);
                        }
                    });
                    $("#upload_excel_cli").dialog("open");
                    $scope.isbulkCreated = isBulkCreate;
                    if(isBulkCreate){
                        $("#upload_excel_cli").dialog("option", "title", "Bulk Create")
                    } else {
                        $("#upload_excel_cli").dialog("option", "title", "Bulk Update")
                    }
                    $scope.$apply();
                }

                $scope.mountCommentsAndAttachmentsModal = (isBulkCreate = true,scope,isSingleUpdate,key,isDelete = false) => {
                    let sc = $('ng-view').scope();
                    propsToPass = {
                        "entityTypeId": _.get(sc.data, "entityTypeId.values"),
                        "entityId": _.get(sc.data, "id.values"),
                        "isSingleUpdate": isSingleUpdate,
                        "key": key,
                        "isDelete": isDelete,
                        "scope": scope,
                        "fromCRC": true,
                        isBulkCreate : (isBulkCreate === "bulkCreate" || isBulkCreate === "bulkUpdate") ? true : false
                    }
                    $scope.isbulkCreated = isBulkCreate;
                    if (isBulkCreate === "save") {
                        propsToPass.title = intl_msg[25708];
                        propsToPass.action = "openReactCommentPopup";
                        if (isSingleUpdate) {
                            propsToPass.isBulk = false;
                        }
                    } else if (isBulkCreate == "bulkCreate") {
                        propsToPass.title = intl_msg[31707];
                        propsToPass.action = "commentAndAttachmentBulkCreatePopup";
                    } else if(isBulkCreate == "bulkUpdate") {
                        propsToPass.title = intl_msg[23756];
                        propsToPass.action = "commentAndAttachmentBulkUpdatePopup";
                    }
                    let mountAt = '#comments_and_attachments_data_grid';
                    var interval = setInterval(() => {
                        if (window.$(mountAt).length) {
                            clearInterval(interval);
                            if (!$(mountAt).children().length) {
                                window.sarc.channelBroadcast("reactDynamicForms", {
                                    actionType: "mountCommunicationPopUp",
                                    mountAt,
                                    propsToPass
                                }, `dfSubscriptions_${$scope.globalData.dynamicFormId}`);
                            } else {
                                window.sarc.channelBroadcast("CommentsAndAttachmentChannel", {
                                    actionType: "mountCommunicationAndAttachment",
                                    payload: propsToPass
                                }, 'CommentsAndAttachmentSubscription')
                            }
                        }
                    }, 10)
                }

                $scope.fileDataChange = (elem) => {
                    $scope.inputElement = elem;
                    var arr = $(elem).val().split("\\");
                    var fileName = arr[arr.length - 1];
                    $("#upload_excel_cli #fileName").text(fileName);
                    $("#upload_excel_cli .file_name").text(fileName);
                    $scope.showError = false;
                    $scope.$apply();
                };

                $scope.templateFileDownload = (isBulkCreate, isSelectedDownload,fromImportTable,bulkMuiData,tableData) =>{
                    let muiData = {};
                    if(!_.isEmpty(bulkMuiData?.selectedRows)){
                        muiData['include'] =  bulkMuiData.selectedRows.map(selectedRow => selectedRow._id);
                    } else if(!_.isEmpty(bulkMuiData?.excludedIds)){
                        muiData['exclude'] =  bulkMuiData.excludedIds.map(excludedRow => excludedRow._id);
                    }
                    if(bulkMuiData?.selectAll){
                        muiData['selectAll'] = true;
                    }
                    let selectedObj ={};
                    $scope.selectedRowsToPost ='';

                    if(muiData.selectAll || !isSelectedDownload){
                        selectedObj = muiData['exclude'];
                    } else if(!_.isEmpty(muiData['exclude'])){
                        selectedObj = muiData['exclude'];
                    } else {
                        selectedObj = muiData['include'];
                        if(_.isEmpty(muiData['include'])){
                            Toaster.create("Please select an entity.",{iconClass:"icon-Information_filled"});
                            return
                        }
                    }

                    muiData['isSelectedDownload'] = isSelectedDownload;

                    if (!_.isEmpty(selectedObj)) {
                        Object.keys(selectedObj).forEach((key, i) => {
                            if (selectedObj[key]) {
                                if ($scope.selectedRowsToPost) {
                                    $scope.selectedRowsToPost += ","
                                }
                                $scope.selectedRowsToPost += selectedObj[key];
                            }
                        });
                    }
                    contractLineItemService.templateFileDownload.call($scope,isBulkCreate,fromImportTable,muiData,tableData)
                }

                $scope.clickApplyBtn = (fromReset,fromRefresh,fromImport, clearFilters,fromYesConfirmation) => {
                    if(!fromYesConfirmation){
                        window.sarc.channelBroadcast("contractLineItemChannel", {
                            actionType: "resetPaginatedData",
                            payload: {fromRefresh},
                        }, fromImport ? "ImportContractLineItemChannelSubscription" : "contractLineItemChannelSubscription");
                    }
                    let fltrQuery = fromImport ? $("#elasticImportSearchFilter textarea").val().replace(/\n/g, "") : $("#elasticSearchFilter textarea").val().replace(/\n/g, "");
                    if (fromReset) {
                        $scope.resetFiltersData(fromImport);
                    }
                    $scope.filterOpened = true;
                    if(!clearFilters) {
                        if (fromImport) {
                            window.sarc.channelBroadcast("sendImportFiltersReactData", {
                                payload: fromReset ? '' : fltrQuery,
                                resetFilters: fromReset,
                                rowDataObj: $scope.rowDataObj,
                            }, "sendImportFiltersReactDataChannel");
                        } else {
                            window.sarc.channelBroadcast("sendCLIFiltersReactData", {
                                payload: fromReset ? '' : fltrQuery,
                                resetFilters: fromReset,
                                rowDataObj: $scope.rowDataObj,
                            }, "sendCLIFiltersReactDataChannel");
                        }
                    }
                }

                $scope.resetFiltersData = (fromImport) =>{
                    if(fromImport) {
                        $("#elasticImportSearchFilter textarea").val("");
                        window.sarc.channelBroadcast('resetCLIFilter', '', `resetCLIFilterchannel_ch2`);
                    }else{
                        $("#elasticSearchFilter textarea").val("");
                        $scope.filterApplied = false;
                        window.sarc.channelBroadcast('resetCLIFilter', '', `resetCLIFilterchannel_ch1`);
                    }
                    $scope.resetFilters = !$scope.resetFilters;
                }

                $scope.generateWordFile = () =>{
                    contractLineItemService.generateDocFile.call($scope,'word',$scope.selectedWordDoc);
                }
                
                $scope.loadDocument = (item) => {
                    $scope.selectedWordDoc = item;
                    contractLineItemService.loadDocument(item);
                }

                $scope.generateDocOpenModal = (docType,update = false) =>{
                    if (docType == 'word' && update) {
                        contractLineItemService.generateDocFile.call($scope, docType, {id: $scope.updatedDocInfo.docId});
                    } else if (docType == 'excel')
                        contractLineItemService.generateDocFile.call($scope, docType);
                    else if (docType == 'word' && !update) {
                        contractLineItemService.getWordFiles(docType).then(res => {
                            if (res && res.openPopup) {
                                $scope.wordLineItemDocs = res.data;
                                $scope.selectedWordDoc = $scope.wordLineItemDocs[0];

                                if ($scope.wordLineItemDocs.length == 1) {
                                    $scope.generatePopupDynamicClass = " singleColumnLayout";
                                } else {
                                    $scope.generatePopupDynamicClass = "";
                                }

                                setTimeout(() => {
                                    contractLineItemService.loadDocument($scope.wordLineItemDocs[0]);
                                }, 1000)
                                $scope.generateDocDialogInstance = $modal.open({
                                    templateUrl: $rootScope.createHtmlUrl("ui2.0/generateDocumentCli.html"),
                                    size: "lg",
                                    backdrop: "static",
                                    keyboard: false,
                                    scope: $scope,
                                    windowClass: "clonepopup contract_line_item_dialog" + $scope.generatePopupDynamicClass,
                                });
                            } else if ($scope.wordLineItemDocs.length == 1) {
                                $scope.selectedWordDoc = $scope.wordLineItemDocs[0];
                                contractLineItemService.generateDocFile.call($scope,'word',$scope.selectedWordDoc);
                            } else {
                                let redirectUrl = window.location.origin + window.location.pathname + '#/templateWizard/cdr/' + res.id + '?cli=true';
                                window.location.href = redirectUrl;
                                return;
                            }
                        });
                    }
                }

                window.sarc.channelSubscription('muiCliEvents', (args) => {
                    $scope.rowDataObj = args.rowDataObj;
                    if (args.actionType == "closeImportModal") {
                        $scope.isReactCLIFilter = false;
                        $scope.resetFiltersData(true);
                        window.sarc.channelUnsubscription('sendImportFiltersReactData', "sendImportFiltersReactDataChannel");
                    } else if (args.actionType == "openCLIFilters") {
                        if(args.fromMainFilter) {
                            $scope.openCLIFilters();
                        }else{
                            $scope.openImportCLIFilters();
                        }
                        $scope.isReactCLIFilter = true;
                    } else if(args.actionType == "downloadBulk"){
                        $scope.templateFileDownload(args.isBulkCreate,args.isSelectedDownload,args.fromImportTable,args.bulkMuiData,args.tableData)
                    } else if(args.actionType == "uploadBulk"){
                        $scope.currentSelectedTable = {
                            templateId:args.tableData.id,
                            tableName:args.tableData.name
                        };
                        $scope.bulkCreateEditUploadHandler(args.isBulkCreate)
                    } else if(args.actionType == "uploadCrcBulk"){
                        $scope.currentSelectedTable = {
                            templateId:args.tableData.id,
                            tableName:args.tableData.name
                        };
                        $scope.bulkCreateEditUploadReactHandler(args.isBulkCreate)
                    }
                    else if (args.actionType == "closeFiltersPopUp") {
                        if ($scope.isReactCLIFilter) {
                            if (args.fromMainFilter) {
                                $("#elasticSearchFilter").dialog('destroy');
                            } else {
                                $("#elasticImportSearchFilter").dialog('destroy');
                            }
                        }
                        $scope.isReactCLIFilter = false;
                    } else if (args.actionType == "selectedRows") {
                        $scope.downloadData['include'] = args.selectedRows;
                        $scope.tableColumn = args.columns;
                    } else if (args.actionType == "resetFilters") {
                        $scope.clickApplyBtn(true, false, args.fromMainFilter ? false: true, args.clearFilters,true);
                    } else if (args.actionType == "generateDocument") {
                        if (args.generateType == 'excel') {
                            $scope.generateDocOpenModal('excel');
                        } else {
                            $scope.generateDocOpenModal('word');
                        }
                    }else if(args.actionType == 'downloadAll') {
                        contractLineItemService.downloadAllTables.call();
                    }else if(args.actionType == "bulkCreateComments"){
                        contractLineItemService.uploadBulkFile.call($scope, {files:args.uploadedFiles}, $scope.isbulkCreated);
                    }else if(args.actionType == "clearFilters"){
                        $scope.resetFiltersData(args.fromMainFilter ? false : true);
                    }
                }, `muiCliEventsChannel`);
            }
        }
    }])
